/* global elementorFrontend, Swiper */
import $ from 'jquery';

export const sliderTeam = () => {
	const el = {
		parent: '.mi-team-slider-wrapper',
	};

	if (!$(el.parent).length) return;

	$(window).on('elementor/frontend/init', function () {
		elementorFrontend.hooks.addAction(
			'frontend/element_ready/team-slider-widget.default',
			function ($element) {
				var $swiperContainer = $element.find('.mi-team-slider');
				if (!$swiperContainer.length) {
					return;
				}

				var initSwiper = function () {
					var params = {
						slidesPerView: 1,
						spaceBetween: 20,
						loop: false,
						pagination: {
							el: $element.find('.mi-team-slider-pagination')[0],
							clickable: true,
						},
						navigation: {
							nextEl: $element.find('.mi-team-slider-next')[0],
							prevEl: $element.find('.mi-team-slider-prev')[0],
						},
						breakpoints: {
							768: {
								slidesPerView: 2,
								spaceBetween: 20,
							},
							1024: {
								slidesPerView: 3,
								spaceBetween: 20,
							},
						},
					};

					if (typeof elementorFrontend.utils.swiper !== 'undefined') {
						const asyncSwiper = elementorFrontend.utils.swiper;
						new asyncSwiper($swiperContainer, params).then(
							function (newSwiperInstance) {
								$swiperContainer.data(
									'swiper',
									newSwiperInstance,
								);
							},
						);
					} else if (typeof Swiper !== 'undefined') {
						var newSwiper = new Swiper($swiperContainer[0], params);
						$swiperContainer.data('swiper', newSwiper);
					}
				};

				initSwiper();
			},
		);
	});
};

try {
	sliderTeam();
} catch (error) {
	console.warn(error);
}
